module.exports = __webpack_public_path__ + "img/mauritania.91960be5.svg";